module.exports = __webpack_public_path__ + "media/images/v2/live_image_bg-498b2e8a253a840cfc145682b7a22753.jpg";